import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import EmployerReport from "@/pages/EmployerReport";
import EmployerAdminGate from "@/components/EmployerAdminGate";

export const Route = createFileRoute("/employer-report")({
  head: () => seoHead("/employer-report"),
  component: () => (
    <EmployerAdminGate><EmployerReport /></EmployerAdminGate>
  ),
});
